import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=c80343dc&scoped=true&"
import script from "./UserDetail.vue?vue&type=script&lang=js&"
export * from "./UserDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserDetail.vue?vue&type=style&index=0&id=c80343dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80343dc",
  null
  
)

export default component.exports